import { ReactNode } from 'react';
import { alpha, styled } from '@mui/material';
import { FONT_DISPLAY } from 'themes/tokens';

const ShellRoot = styled('div')({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

const ShellHeader = styled('header')(({ theme }) => ({
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const ShellTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  fontFamily: FONT_DISPLAY,
  fontSize: '1.15rem',
  fontWeight: 700,
  letterSpacing: '-0.01em',
  color: theme.palette.text.primary,
}));

const ShellBody = styled('div')(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: theme.spacing(3),
}));

const ShellFooter = styled('footer')(({ theme }) => ({
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2, 3),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.03),
}));

type Props = {
  title?: ReactNode;
  headerActions?: ReactNode;
  footer: ReactNode;
  children: ReactNode;
  bodyClassName?: string;
};

export const SettingsFormShell = ({ title, headerActions, footer, children, bodyClassName }: Props) => {
  const hasHeader = title != null || headerActions != null;
  return (
    <ShellRoot>
      {hasHeader && (
        <ShellHeader>
          {typeof title === 'string' ? <ShellTitle>{title}</ShellTitle> : title}
          {headerActions}
        </ShellHeader>
      )}
      <ShellBody className={bodyClassName}>{children}</ShellBody>
      <ShellFooter>{footer}</ShellFooter>
    </ShellRoot>
  );
};

export default SettingsFormShell;
